"use strict";
/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2022 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutFactory = void 0;
const Checkout_1 = require("./Checkout");
const CheckoutData_1 = require("./CheckoutData");
const CheckoutRequestHandler_1 = require("./requestHandlers/CheckoutRequestHandler");
class CheckoutFactory {
    constructor() {
        this.existingCheckout = null;
        this.awaitingCheckoutPromise = null;
        this.awaitingCheckoutPutPromise = null;
    }
    clearCheckout() {
        this.existingCheckout = null;
    }
    generateCheckout(shopId, cart, config, isBroadcastAllowed) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.existingCheckout && this.existingCheckout.cartData.cartId === cart.cartId) {
                return this.existingCheckout;
            }
            if (this.awaitingCheckoutPromise) {
                yield this.awaitingCheckoutPromise;
                if (this.awaitingCheckoutPutPromise) {
                    yield this.awaitingCheckoutPutPromise;
                }
                return this.existingCheckout;
            }
            if (this.awaitingCheckoutPutPromise) {
                yield this.awaitingCheckoutPutPromise;
                return this.existingCheckout;
            }
            this.awaitingCheckoutPromise = CheckoutRequestHandler_1.CheckoutRequestHandler.createCheckout(shopId, cart.cartId);
            const checkoutResponseData = yield this.awaitingCheckoutPromise;
            let rawCheckoutData;
            if (config) {
                this.awaitingCheckoutPutPromise = CheckoutRequestHandler_1.CheckoutRequestHandler.putParams(shopId, checkoutResponseData.checkoutId, config);
                rawCheckoutData = yield this.awaitingCheckoutPutPromise;
            }
            else {
                rawCheckoutData = checkoutResponseData;
            }
            const checkoutData = new CheckoutData_1.CheckoutData(rawCheckoutData);
            const checkout = new Checkout_1.Checkout(shopId, checkoutData, isBroadcastAllowed);
            this.existingCheckout = checkout;
            this.awaitingCheckoutPutPromise = null;
            this.awaitingCheckoutPromise = null;
            cart.emitter.on(() => checkout.get());
            return checkout;
        });
    }
}
const checkoutFactory = new CheckoutFactory();
exports.CheckoutFactory = checkoutFactory;
